import { ElementType, ReactNode } from 'react';

import { useAutoTracking } from '../../hooks/useAutoTracking';
import { ElementId, TrackingData } from '../../types';
import { TrackingScope } from '../TrackingScope';

export const AutoTrackingScope = ({
  elementId,
  data,
  component: Component = 'div',
  children,
  ...rest
}: {
  elementId: ElementId;
  data?: TrackingData;
  component?: ElementType;
  children: ReactNode;
} & Omit<React.HTMLAttributes<HTMLElement>, 'children'>) => {
  const autoTrackRef = useAutoTracking();
  return (
    <TrackingScope elementId={elementId} data={data}>
      <Component ref={autoTrackRef} {...rest}>
        {children}
      </Component>
    </TrackingScope>
  );
};
